import { Icon, InlineAlert } from '@rbilabs/universal-components';
import { StyleSheet, View } from 'react-native';
import { Typography } from 'ucl/components/text/Typography';

import ActionButton, { ActionButtonVariants } from 'components/action-button';
import { classifyPaymentMethods } from 'components/payment-method/utils';
import { PrepaidBalanceInfo } from 'components/prepaid-balance-info';
import { t, tRich } from 'state/intl/translations';
import { useUIContext } from 'state/ui';
import { primitive, spacing } from 'styles/constants';

import { SelectorSelection } from './selector-selection';
import { SelectorPrepaidReloadProps } from './types';

export function SelectorPrepaidReload({
  methods,
  selectedMethodId,
  reloadAmount,
  onChange,
  prepaidBalance = 0,
  orderTotal = 0,
}: SelectorPrepaidReloadProps) {
  const { formatCurrencyForUser } = useUIContext();
  const formattedReloadAmount = formatCurrencyForUser(reloadAmount);
  const { selectedMethod } = classifyPaymentMethods(methods, selectedMethodId ?? '');

  const reloadExplanationText = tRich('reloadExplanation.bk', {
    reloadAmount: (
      <Typography fontFamily="heading" fontSize="xs">
        {formattedReloadAmount}
      </Typography>
    ),
  });
  const youWillBeChargedText = t('youWillBeCharged', { reloadAmount: formattedReloadAmount });

  return (
    <View style={styles.container}>
      <PrepaidBalanceInfo prepaidBalance={prepaidBalance} orderTotal={orderTotal} />
      <InlineAlert
        message={reloadExplanationText}
        status="info"
        backgroundColor="#FFCFAD"
        style={{ marginTop: 16 }}
      />
      <View style={styles.labelContainer}>
        <Typography style={styles.instructionText}>
          {t('loadWith')}
          {':'}
        </Typography>
        <Typography style={{ marginBottom: 8, fontSize: 12 }}>{youWillBeChargedText}</Typography>
        <View style={styles.divider} />
      </View>

      {methods.length > 0 ? (
        <SelectorSelection
          methods={methods}
          selectedMethodId={selectedMethod?.accountIdentifier ?? undefined}
          onChange={onChange}
        />
      ) : (
        <ActionButton
          testID="add-reload-payment-btn"
          width="100%"
          height="$10"
          marginY="$6"
          _text={{ fontSize: 'sm' }}
          variant={ActionButtonVariants.OUTLINE}
          leftIcon={<Icon variant="add" aria-hidden />}
          onPress={onChange}
        >
          {t('addPayment')}
        </ActionButton>
      )}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    marginVertical: spacing.$4,
  },
  instructionText: {
    fontFamily: primitive.fontFamily.$headers,
    color: primitive.$bbqBrown,
    fontSize: 18,
    fontWeight: 'normal',
    marginTop: spacing.$3,
  },
  divider: {
    borderBottomWidth: 1,
    borderBottomColor: primitive.$blackOpacity10,
    marginBottom: spacing.$4,
  },
  labelContainer: {
    marginTop: spacing.$3,
  },
});
